import { render } from "./WhaleQuickView.vue?vue&type=template&id=4f83271a&scoped=true"
import script from "./WhaleQuickView.vue?vue&type=script&lang=js"
export * from "./WhaleQuickView.vue?vue&type=script&lang=js"

import "./WhaleQuickView.vue?vue&type=style&index=0&id=4f83271a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f83271a"]])

export default __exports__